const config = {
  baseApi: process.env.VUE_APP_BASE_API || '',
  timeout: 60000
}

export default config
